export const shouldIncludeSmartSchoolButton = () => {
  const domainSplit = window.location.hostname.split('.');
  const domain = domainSplit[domainSplit.length - 1];
  return ['localhost', 'be'].includes(domain);
};
